module.exports = __webpack_public_path__ + "media/customizations/wildflowerranch/back-08d32e23f2b5dbfd23fef860e78990dc.jpg";